import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getReviewStatus } from '~/entities/consignment'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { TABLE_COLUMNS } from '../config'
import { useFilters, usePaginationSelectors } from '../model'

export function useConsignments() {
  const { filters } = useFilters()
  const { currentPage, evaluationKeysMap } = usePaginationSelectors({ pageSize: filters.pageSize })
  const queryClient = useQueryClient()

  // Cancel query on unmount
  useEffect(() => {
    return () => {
      queryClient.cancelQueries({ queryKey: apiClient.listConsignmentsConsignmentsGetQueryKey() })
    }
  }, [queryClient])

  return useSuspenseQuery({
    ...apiClient.listConsignmentsConsignmentsGetOptions({
      query: {
        limit: filters.pageSize,
        review_status: getReviewStatus(filters.status),
        consignment_key: filters.assetIdQuery || null,
        last_evaluated_key: evaluationKeysMap[currentPage],
        scan_index_forward:
          filters.sortBy === TABLE_COLUMNS.DATE_RECEIVED && filters.sortOrder === 'asc'
            ? true
            : undefined,
      },
    }),
    refetchInterval: 1000 * 30,
  })
}
